import React from "react";

const Team = () => {
  return (
    <section className="pt-20 pb-10 lg:pb-20">
      <div className="text-center mx-auto mb-[60px] max-w-[510px]">
        <span
        data-aos="fade-up"
        data-aos-easing="gradient(0,0,1000)"
        data-aos-duration="2400"
        className="font-semibold text-lg text-primary mb-2 block">
          Our Team
        </span>
        <h2
        data-aos="fade-up"
        data-aos-easing="gradient(0,0,1000)"
        data-aos-duration="1900"
          className="
                          font-bold
                          text-3xl
                          sm:text-4xl
                          md:text-[40px]
                        text-secondary
                          mb-4
                          "
        >
          Our Awesome Team
        </h2>
        <p
        data-aos="fade-up"
        data-aos-easing="gradient(0,0,1000)"
        data-aos-duration="2100"
        className="text-base text-secondary">
          There are many variations of passages of Lorem Ipsum available but the
          majority have suffered alteration in some form.
        </p>
      </div>
      <div className="flex flex-wrap mx-auto w-11/12">
        <div className="w-full md:w-1/2 xl:w-1/4 px-4">
          <div 
          data-aos="flip-right"
          data-aos-easing="gradient(0,0,1200)"
          data-aos-duration="2200"
          className="max-w-[370px] w-full mx-auto mb-10">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://cdn.tailgrids.com/1.0/assets/images/team/team-01/image-01.jpg"
                alt=""
                className="w-full"
              />
              <div className="absolute w-full bottom-5 left-0 text-center">
                <div
                  className="
                                bg-primary-content
                                relative
                                rounded-lg
                                overflow-hidden
                                mx-5
                                py-5
                                px-3
                                "
                >
                  <h3 className="text-base font-semibold text-secondary">
                    Coriss Ambady
                  </h3>
                  <p className="text-sm text-secondary">Web Developer</p>
                  <div>
                    <span className="absolute left-0 bottom-0">
                      <svg
                        width="61"
                        height="30"
                        viewBox="0 0 61 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16"
                          cy="45"
                          r="45"
                          fill="#13C296"
                          fill-opacity="0.11"
                        />
                      </svg>
                    </span>
                    <span className="absolute top-0 right-0">
                      <svg
                        width="20"
                        height="25"
                        viewBox="0 0 20 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="0.706257"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 0.706257 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 6.39669 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 12.0881 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 17.7785 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 0.706257 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 6.39669 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 12.0881 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 17.7785 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 0.706257 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 6.39669 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 12.0881 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 17.7785 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 0.706257 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 6.39669 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 12.0881 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 17.7785 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 0.706257 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 6.39669 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 12.0881 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 17.7785 1.58989)"
                          fill="#3056D3"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
         data-aos="flip-right"
         data-aos-easing="gradient(0,0,1200)"
         data-aos-duration="2200"
        className="w-full md:w-1/2 xl:w-1/4 px-4">
          <div className="max-w-[370px] w-full mx-auto mb-10">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://cdn.tailgrids.com/1.0/assets/images/team/team-01/image-02.jpg"
                alt=""
                className="w-full"
              />
              <div className="absolute w-full bottom-5 left-0 text-center">
                <div
                  className="
                                bg-primary-content
                                relative
                                rounded-lg
                                overflow-hidden
                                mx-5
                                py-5
                                px-3
                                "
                >
                  <h3 className="text-base font-semibold text-secondary">
                    Glorius Cristian
                  </h3>
                  <p className="text-sm text-secondary">App Developer</p>
                  <div>
                    <span className="absolute left-0 bottom-0">
                      <svg
                        width="61"
                        height="30"
                        viewBox="0 0 61 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16"
                          cy="45"
                          r="45"
                          fill="#13C296"
                          fill-opacity="0.11"
                        />
                      </svg>
                    </span>
                    <span className="absolute top-0 right-0">
                      <svg
                        width="20"
                        height="25"
                        viewBox="0 0 20 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="0.706257"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 0.706257 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 6.39669 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 12.0881 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 17.7785 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 0.706257 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 6.39669 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 12.0881 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 17.7785 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 0.706257 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 6.39669 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 12.0881 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 17.7785 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 0.706257 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 6.39669 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 12.0881 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 17.7785 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 0.706257 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 6.39669 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 12.0881 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 17.7785 1.58989)"
                          fill="#3056D3"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
         data-aos="flip-right"
         data-aos-easing="gradient(0,0,1200)"
         data-aos-duration="2200"
        className="w-full md:w-1/2 xl:w-1/4 px-4">
          <div className="max-w-[370px] w-full mx-auto mb-10">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://cdn.tailgrids.com/1.0/assets/images/team/team-01/image-03.jpg"
                alt=""
                className="w-full"
              />
              <div className="absolute w-full bottom-5 left-0 text-center">
                <div
                  className="
                                bg-primary-content
                                relative
                                rounded-lg
                                overflow-hidden
                                mx-5
                                py-5
                                px-3
                                "
                >
                  <h3 className="text-base font-semibold text-secondary">
                    Jackie Sanders
                  </h3>
                  <p className="text-sm text-secondary">UI/UX Designer</p>
                  <div>
                    <span className="absolute left-0 bottom-0">
                      <svg
                        width="61"
                        height="30"
                        viewBox="0 0 61 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16"
                          cy="45"
                          r="45"
                          fill="#13C296"
                          fill-opacity="0.11"
                        />
                      </svg>
                    </span>
                    <span className="absolute top-0 right-0">
                      <svg
                        width="20"
                        height="25"
                        viewBox="0 0 20 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="0.706257"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 0.706257 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 6.39669 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 12.0881 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 17.7785 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 0.706257 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 6.39669 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 12.0881 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 17.7785 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 0.706257 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 6.39669 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 12.0881 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 17.7785 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 0.706257 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 6.39669 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 12.0881 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 17.7785 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 0.706257 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 6.39669 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 12.0881 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 17.7785 1.58989)"
                          fill="#3056D3"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
         data-aos="flip-right"
         data-aos-easing="gradient(0,0,1200)"
         data-aos-duration="2200"
        className="w-full md:w-1/2 xl:w-1/4 px-4">
          <div className="max-w-[370px] w-full mx-auto mb-10">
            <div className="relative rounded-lg overflow-hidden">
              <img
             
              src="https://cdn.tailgrids.com/1.0/assets/images/team/team-01/image-04.jpg" alt="" className="w-full"/>
              <div className="absolute w-full bottom-5 left-0 text-center">
                <div
                  className="
                                bg-primary-content
                                relative
                                rounded-lg
                                overflow-hidden
                                mx-5
                                py-5
                                px-3
                                "
                >
                  <h3 className="text-base font-semibold text-secondary">
                    Nikolas Brooten
                  </h3>
                  <p className="text-sm text-secondary">Sales Manager</p>
                  <div>
                    <span className="absolute left-0 bottom-0">
                      <svg
                        width="61"
                        height="30"
                        viewBox="0 0 61 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16"
                          cy="45"
                          r="45"
                          fill="#13C296"
                          fill-opacity="0.11"
                        />
                      </svg>
                    </span>
                    <span className="absolute top-0 right-0">
                      <svg
                        width="20"
                        height="25"
                        viewBox="0 0 20 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="0.706257"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 0.706257 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 6.39669 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 12.0881 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="24.3533"
                          r="0.646687"
                          transform="rotate(-90 17.7785 24.3533)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 0.706257 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 6.39669 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 12.0881 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="18.6624"
                          r="0.646687"
                          transform="rotate(-90 17.7785 18.6624)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 0.706257 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 6.39669 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 12.0881 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="12.9717"
                          r="0.646687"
                          transform="rotate(-90 17.7785 12.9717)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 0.706257 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 6.39669 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 12.0881 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="7.28077"
                          r="0.646687"
                          transform="rotate(-90 17.7785 7.28077)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="0.706257"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 0.706257 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="6.39669"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 6.39669 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="12.0881"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 12.0881 1.58989)"
                          fill="#3056D3"
                        />
                        <circle
                          cx="17.7785"
                          cy="1.58989"
                          r="0.646687"
                          transform="rotate(-90 17.7785 1.58989)"
                          fill="#3056D3"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Team;